module.exports = __webpack_public_path__ + "img/bitlabImg1x.37c0ab81.png";